function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3374",
  "data-name": "Group 3374",
  transform: "translate(-50 -316)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2761",
  "data-name": "Rectangle 2761",
  width: 275,
  height: 64,
  rx: 6,
  transform: "translate(50 316)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2447",
  "data-name": "Group 2447",
  transform: "translate(118.556 330.733)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2445",
  "data-name": "Group 2445",
  transform: "translate(37.622)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_121",
  "data-name": "Path 121",
  d: "M667.962,834.5h-6.234l-1.5,4.42h-2.641l5.9-16.352h2.744l5.9,16.352h-2.685Zm-5.588-2.039h4.94l-2.434-7.173h-.068Z",
  transform: "translate(-657.591 -822.29)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_122",
  "data-name": "Path 122",
  d: "M678.223,831.169c0,3.7-1.983,6.085-4.976,6.085a4.041,4.041,0,0,1-3.75-2.086h-.057v5.9h-2.448V825.207h2.369v1.983h.045a4.232,4.232,0,0,1,3.8-2.108C676.229,825.082,678.223,827.475,678.223,831.169Zm-2.516,0c0-2.414-1.248-4-3.151-4-1.87,0-3.128,1.619-3.128,4,0,2.4,1.258,4.01,3.128,4.01C674.459,835.179,675.707,833.6,675.707,831.169Z",
  transform: "translate(-650.922 -820.504)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_123",
  "data-name": "Path 123",
  d: "M685.9,831.169c0,3.7-1.984,6.085-4.976,6.085a4.045,4.045,0,0,1-3.752-2.086h-.056v5.9h-2.448V825.207h2.369v1.983h.044a4.232,4.232,0,0,1,3.8-2.108C683.9,825.082,685.9,827.475,685.9,831.169Zm-2.516,0c0-2.414-1.248-4-3.15-4-1.87,0-3.128,1.619-3.128,4,0,2.4,1.258,4.01,3.128,4.01C682.137,835.179,683.385,833.6,683.385,831.169Z",
  transform: "translate(-645.477 -820.504)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_124",
  "data-name": "Path 124",
  d: "M687.351,834.474c.181,1.62,1.757,2.686,3.909,2.686,2.063,0,3.547-1.065,3.547-2.526,0-1.27-.894-2.029-3.014-2.55l-2.12-.511c-3-.725-4.4-2.13-4.4-4.409,0-2.82,2.458-4.759,5.948-4.759,3.456,0,5.826,1.939,5.906,4.759h-2.47c-.149-1.631-1.5-2.617-3.468-2.617s-3.321,1-3.321,2.448c0,1.156.862,1.836,2.969,2.357l1.8.443c3.355.793,4.748,2.14,4.748,4.533,0,3.058-2.436,4.974-6.313,4.974-3.625,0-6.075-1.87-6.232-4.827Z",
  transform: "translate(-638.257 -822.404)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_125",
  "data-name": "Path 125",
  d: "M697.017,823.5v2.82h2.267v1.938h-2.267v6.572c0,1.021.453,1.5,1.45,1.5a7.964,7.964,0,0,0,.805-.056V838.2a6.839,6.839,0,0,1-1.359.113c-2.414,0-3.355-.908-3.355-3.219v-6.834h-1.733v-1.938h1.733V823.5Z",
  transform: "translate(-632.598 -821.623)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_126",
  "data-name": "Path 126",
  d: "M697.371,831.177c0-3.75,2.209-6.107,5.653-6.107s5.656,2.357,5.656,6.107-2.188,6.108-5.656,6.108S697.371,834.938,697.371,831.177Zm8.815,0c0-2.572-1.179-4.092-3.162-4.092s-3.161,1.53-3.161,4.092c0,2.583,1.178,4.091,3.161,4.091S706.186,833.76,706.186,831.177Z",
  transform: "translate(-629.373 -820.513)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_127",
  "data-name": "Path 127",
  d: "M705.167,825.207H707.5v2.029h.056a2.843,2.843,0,0,1,2.868-2.154,3.691,3.691,0,0,1,.838.092v2.289a3.4,3.4,0,0,0-1.1-.149,2.466,2.466,0,0,0-2.55,2.743v7.072h-2.448Z",
  transform: "translate(-623.843 -820.504)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_128",
  "data-name": "Path 128",
  d: "M719.8,833.635c-.33,2.166-2.438,3.65-5.133,3.65-3.468,0-5.622-2.323-5.622-6.051s2.164-6.164,5.518-6.164c3.3,0,5.374,2.265,5.374,5.88v.838h-8.422v.148a3.105,3.105,0,0,0,3.209,3.376,2.693,2.693,0,0,0,2.752-1.677Zm-8.273-3.557h5.96a2.866,2.866,0,0,0-2.925-3.026A3.018,3.018,0,0,0,711.525,830.078Z",
  transform: "translate(-621.093 -820.513)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2444",
  "data-name": "Group 2444",
  transform: "translate(37.557 22.697)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_129",
  "data-name": "Path 129",
  d: "M660.71,846.792l.1-1.26a4.825,4.825,0,0,0,1.463.233c.45,0,.622-.043.841-.349a7.035,7.035,0,0,0,.665-3.562c0-1.3-.405-1.68-1.432-1.68-.232,0-.494.015-.783.031a21.1,21.1,0,0,1-2.723,6.342l-1.2-.651a17.044,17.044,0,0,0,2.533-5.562,21,21,0,0,0-2.359.393l-.261-1.277c.884-.159,1.94-.3,2.925-.39a26.765,26.765,0,0,0,.449-2.911l1.421.159c-.132.882-.29,1.767-.494,2.636h.566c1.839,0,2.723.913,2.723,2.853a8.991,8.991,0,0,1-.839,4.3,1.781,1.781,0,0,1-1.738.926A7.911,7.911,0,0,1,660.71,846.792Zm4.663-7.8,1.058-.711a8.155,8.155,0,0,1,2.477,5.36l-1.391.215A6.754,6.754,0,0,0,665.373,838.987Z",
  transform: "translate(-657.553 -835.351)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_130",
  "data-name": "Path 130",
  d: "M667.96,847.014l-.289-1.3c.362.031.839.045,1.13.045,2.867,0,3.954-.81,3.954-2.014,0-.955-.622-1.506-2.013-1.506a6.206,6.206,0,0,0-3.968,1.942l-1.116-.492c0-2.767.291-4.043,1.231-5.432l1.289.421a5.667,5.667,0,0,0-1.1,3.766,7.407,7.407,0,0,1,3.955-1.347c1.94,0,3.142,1,3.142,2.621,0,2.056-1.622,3.318-5.518,3.318C668.468,847.029,668.193,847.014,667.96,847.014Zm-1.347-9.617.362-1.275a39.743,39.743,0,0,1,5.692,1.3l-.347,1.26A32.55,32.55,0,0,0,666.613,837.4Z",
  transform: "translate(-651.803 -835.37)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_131",
  "data-name": "Path 131",
  d: "M673.821,846.328a9.148,9.148,0,0,0,3.9-2.521,16.369,16.369,0,0,0-2.708-1.824l.8-1a17.731,17.731,0,0,1,2.752,1.737,9.149,9.149,0,0,0,1.419-3.345h-3.694a14.892,14.892,0,0,1-3.157,3.636l-1.056-.911a13.744,13.744,0,0,0,4.027-5.533l1.39.333c-.159.405-.318.824-.508,1.217h3.593l1.027.477c-.738,4.171-3.157,7.516-6.936,8.865Zm6.113-10.111.81-.391a8.723,8.723,0,0,1,1.029,1.781l-.913.422A7.95,7.95,0,0,0,679.934,836.217Zm1.81-.145.826-.39a9.724,9.724,0,0,1,1.058,1.826l-.913.39A8,8,0,0,0,681.744,836.071Z",
  transform: "translate(-647.256 -835.682)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_132",
  "data-name": "Path 132",
  d: "M682.758,847.067l-.737-1.173c3.88-.94,5.024-3.49,5.1-6.386h-6.084v2.911h-1.463v-4.143h3.636v-2.128h1.463v2.128h2.709l1.331.378C688.538,842.767,687.163,845.91,682.758,847.067Z",
  transform: "translate(-641.933 -835.351)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_133",
  "data-name": "Path 133",
  d: "M686.568,837.946l.81-1.19a17.977,17.977,0,0,1,3.562,2.159l-.926,1.246A16.985,16.985,0,0,0,686.568,837.946Zm.274,7.14a11.262,11.262,0,0,0,8.359-6.026l.956,1.072a12.255,12.255,0,0,1-8.762,6.3Z",
  transform: "translate(-636.971 -834.919)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_134",
  "data-name": "Path 134",
  d: "M702.9,845.614h-9.111v-8.619H702.9Zm-7.675-7.287v5.954h6.227v-5.954Z",
  transform: "translate(-631.847 -834.751)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_135",
  "data-name": "Path 135",
  d: "M711,840.387H700.761V838.91H711Z",
  transform: "translate(-626.903 -833.392)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_136",
  "data-name": "Path 136",
  d: "M708.79,836.275h1.433v3.708a44.461,44.461,0,0,1,5.533,2.767l-.81,1.273a35.166,35.166,0,0,0-4.723-2.533v5.59H708.79Zm3.4.783.855-.405a9.507,9.507,0,0,1,1.029,1.969l-.942.421A8.538,8.538,0,0,0,712.193,837.058Zm1.649-.624.87-.405A9.365,9.365,0,0,1,715.8,838l-.942.42A9.4,9.4,0,0,0,713.843,836.434Z",
  transform: "translate(-621.208 -835.436)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2446",
  "data-name": "Group 2446",
  transform: "translate(0 0.152)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_19",
  "data-name": "Group 19"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_137",
  "data-name": "Path 137",
  d: "M658.345,836.956a7.614,7.614,0,0,1,3.626-6.388,7.791,7.791,0,0,0-6.14-3.32c-2.583-.272-5.087,1.545-6.4,1.545-1.342,0-3.368-1.518-5.55-1.474a8.176,8.176,0,0,0-6.882,4.2c-2.974,5.152-.755,12.723,2.094,16.887,1.426,2.038,3.092,4.316,5.273,4.234,2.133-.087,2.932-1.361,5.508-1.361,2.55,0,3.3,1.361,5.523,1.309,2.291-.036,3.733-2.048,5.109-4.106a16.89,16.89,0,0,0,2.337-4.757A7.358,7.358,0,0,1,658.345,836.956Z",
  transform: "translate(-635.582 -819.139)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_138",
  "data-name": "Path 138",
  d: "M648.523,827.864a7.5,7.5,0,0,0,1.715-5.371,7.628,7.628,0,0,0-4.935,2.554,7.133,7.133,0,0,0-1.759,5.171A6.306,6.306,0,0,0,648.523,827.864Z",
  transform: "translate(-629.961 -822.493)",
  fill: "#fff"
})))));

function SvgAppStore(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 275,
    height: 64,
    viewBox: "0 0 275 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.e18595f8.svg";
export { ForwardRef as ReactComponent };